import { useLingui } from "@lingui/react";
import type { MobilityAd } from "@mobility-item-page/types";
import { useMemo } from "react";
import { Icon } from "../Icon.tsx";
import Detail from "./Detail.tsx";
import { deriveSummaryItems } from "./deriveSummaryItems.ts";

export const Summary = ({ ad }: { ad: MobilityAd }) => {
  const { i18n } = useLingui();
  const summaryItems = useMemo(() => deriveSummaryItems(ad, i18n), [ad, i18n]);

  if (summaryItems.length === 0) {
    return <div className="pt-40" />;
  }

  return (
    <div className="grid mt-16 gap-24 md:gap-8 mt-40 md:mt-24 grid-cols-2 md:grid-cols-[auto_auto_auto_auto]">
      {summaryItems.map((item) => {
        const { icon: IconName, label, value } = item;
        return <Detail key={item.value} icon={<Icon name={IconName} size="large" />} label={label} info={value} />;
      })}
    </div>
  );
};
